export default __webpack_public_path__ + "static/media/pay_config.00fa12d5.svg";